import { gql } from "@apollo/client";


export const SAVE_VISITA_CP_DATOS_CLINICOS = gql`
mutation SaveVisitaCPDatosClinicos($input: AddVisitaCPDatosClinicosInput!) {
  saveVisitaCPDatosClinicos(input: $input) {
    idVisita
  }
}`;

export const adaptVisitaCPDatosClinicosInput = (data, alergiaOtrosId) => ({
  idVisita: data?.idVisita,

  enfermedadOncologica: !!data?.enfermedadOncologica,
  soporteNutricional: !!data?.soporteNutricional,

  medicoCabecera: data?.medicoCabecera || null,

  idComboRIValorECOG: data?.idComboRIValorECOG ?? data?.ecog ?? null,
  examenFisico: data?.examenFisico || null,

  sondaVesical: !!data?.sondaVesical,
  cateter: !!data?.cateter,
  sondaNasogastrica: !!data?.sondaNasogastrica,

  idComboRIValorLANSKY: data?.idComboRIValorLANSKY ?? data?.lansky ?? null,
  idComboRIValorEscalaDolor: data?.idComboRIValorEscalaDolor ?? data?.escalaDolor ?? null,

  fLACCR: !!data?.fLACCR,
  resultadoFLACCR: data?.resultadoFLACCR ?? null,
  gustaveRoussy: !!data?.gustaveRoussy,
  resultadoGustaveRoussy: data?.resultadoGustaveRoussy ?? null,

  pedFPSR: !!data?.pedFPSR,
  resultadoFPSR: data?.resultadoFPSR ?? null,
  escalaNumericaDolor: !!data?.escalaNumericaDolor,
  resultadoEscalaNumericaDolor: data?.resultadoEscalaNumericaDolor ?? null,

  nauseas: data?.nauseas ?? null,
  dolor: data?.dolor ?? null,
  disnea: data?.disnea ?? null,
  ansiedad: data?.ansiedad ?? null,
  depresion: data?.depresion ?? null,
  anorexia: data?.anorexia ?? null,
  bienestar: data?.bienestar ?? null,
  cansancio: data?.cansancio ?? null,
  insomnio: data?.insomnio ?? null,
  somnolencia: data?.somnolencia ?? null,
  constipacion: data?.constipacion ?? null,
  resultadoESAS: data?.resultadoESAS ?? null,
  eSAS: data?.eSAS ?? false,
  idESAS: data?.idESAS ?? null,
  listaAlergia: data?.alergiasDatosClinicos?.map((id) => ({
    idAlergia: id,
    descripcionAlergiaOtro: id === alergiaOtrosId ? data?.descripcionAlergiaOtro : ''
  })) || [],
  listaDiagnostico: data?.listaDiagnostico?.map((x) => ({
    idDiagnostico: x.codigo,
    idItemDiagnostico: x.codigoItem
  }))
});


export const SAVE_VISITA_CP_SOCIO_FAMILIAR = gql`
mutation SaveVisitaCPSocioFamiliar($input: AddVisitaCPSocioFamiliarInput!) {
  saveVisitaCPSocioFamiliar(input: $input) {
    idVisita
  }
}`;

export const adaptVisitaCPSocioFamiliarInput = (data) => ({
  idVisita: data?.idVisita,
  comunicacionDecisiones: data?.comunicacionDecisiones ?? data?.comunicacionDecisiones ?? null,
  espacioCuidado: data?.espacioCuidado ?? null,
  cuidadorPrincipal: data?.cuidadorPrincipal ?? null
});


export const SAVE_VISITA_CP_TRATAMIENTOS = gql`
mutation SaveVisitaCPTratamientos($input: AddVisitaCPTratamientoInput!) {
  saveVisitaCPTratamientos(input: $input) {
    idVisita
  }
}`;

export const adaptVisitaCPTratamientosInput = (data) => ({
  idVisita: data?.idVisita,
  medicacionDosificacion: Array.isArray(data?.tratamientos) ?
  data.tratamientos.map((x) => String(x)) :
  []
});


export const SAVE_SITUACION_ACTUAL = gql`
mutation SaveVisitaCPSituacionActual($input: AddVisitaCPSituacionActualInput!) {
  saveVisitaCPSituacionActual(input: $input) {
    idVisita
  }
}`;

export const adaptVisitaCPSituacionActualInput = (data) => ({
  idVisita: data?.idVisita,
  observacionSituacionActual: data?.obsSituacionActual ?? data?.observacionSituacionActual ?? null
});


export const SAVE_VISITA_CP_REQUERIMIENTOS_ACTUALES = gql`
mutation SaveVisitaCPRequerimientosActuales($input: AddVisitaCPRequerimientosActualesInput!) {
  saveVisitaCPRequerimientosActuales(input: $input) {
    idVisita
  }
}`;

export const adaptVisitaCPRequerimientosActualesInput = (data) => ({
  idVisita: data?.idVisita,
  observacionRequerimientosActuales: data?.obsRequerimientosActuales ?? data?.observacionRequerimientosActuales ?? null
});


export const CREATE_CP_ADICIONAL_VISITA = gql`
mutation CreateAdicionalVisita($input: AddVisitaCPAdicionales!) {
  createAdicionalVisita(input: $input) {
    idVisita
  }
}`;

export const adaptCPAdicionalVisitaInput = (data) => ({
  idVisita: data?.idVisita,
  idComboRIValorReqAdicional: Array.isArray(data?.idComboRIValorReqAdicional) ?
  data.idComboRIValorReqAdicional.map(Number) :
  []
});


export const SAVE_OPIOIDES_VISITA = gql`
  mutation CreateOpioidesVisita($input: [AddVisitaCPOpioidesInput!]!) {
    createOpioidesVisita(input: $input) {
      idOpioideVisita
    }
  }
`;

export const adaptCreateOpioidesVisitaInput = (idVisita, items) => {
  return items?.map((item) => ({
    idVisita: idVisita,
    idOpioide: item.idOpioide,
    dosis: item.dosis || null,
    idComboOpioide: item.idComboOpioide || null
  }));
};